class AbnLookupService {
    constructor(Restangular) {
        this._api = Restangular.one('abn-verification');
    }

    lookupAbn(arg) {
        return this._api.get({ abn: arg });
    }
}

AbnLookupService.$inject = ['Restangular'];

module.exports = { AbnLookupService };



// WEBPACK FOOTER //
// ./src/auth/abn/abn-lookup.service.js